<template>
<div>

  <div class="header-banner">
    <section class="section header-block">
        <div class="container">
            <h1>{{ play.title }}</h1>
        </div>
    </section>
  </div>

  <section class="section">
    <div class="container">

      <div class="columns top-section">
        <div class="column is-two-thirds">

          <section class="block">
            <img :src="'/images/plays' + play.mainimage" :alt="play.title" class="img-fluid">
            
            <div class="block-with-vsmall-vertical-gap">
              <div>
                  <h1 class="title featuredplay-title">{{ play.title }}</h1>
                  <span class="featuredplay-message tag is-warning is-medium" v-if="play.message">{{ play.message }}</span>
              </div>

              <div class="content">
                <p v-html="play.blurb" />
              </div>

              <div class="field is-grouped buttons block-with-medium-vertical-gap">
                  <div class="control" v-if="play.buylink">
                      <a class="button is-primary is-medium" :href="play.buylink">Buy tickets</a>
                  </div>
                  <!-- <div class="control" v-if="isStatus('audition')">
                      <router-link :to="{name: 'play-audition', params: {slug: play.slug}}" class="button is-link is-medium">Apply to audition</router-link>
                  </div> -->
              </div>

            </div>



          </section>
        </div>


        <aside class="column">

          <div class="cards" v-if="play.videolinks">
            <ul>
              <li class="vertical-card-gap" v-for="link in play.videolinks" :key="link._id">
                <a :href="link" alt="Video" title="Video" class="video" target="_blank">
                  <img :src="youtubeThumbnailFrom(link)" />
                </a>
              </li>
            </ul>
          </div>

          <div class="cards" v-if="play.reviews">
            <!-- <h3 class="subtitle">Reviews</h3> -->
            <ul>
              <li class="card vertical-card-gap" v-for="(review, index) in play.reviews" :key="review._id">
                <div class="card-content">
                  <p v-html="truncatedText(review.text)" />
                  <router-link :to="{name: 'review', params: {slug: play.slug, reviewindex: index}}">
                    <div class="has-text-right reviewer">Read full review by {{ review.reviewer }}</div>
                  </router-link>
                </div>
              </li>
            </ul>
          </div>

        </aside>

      </div>

    </div>
  </section>



  <div v-if="play.prices || play.dates || play.venues">
    <div class="grey-block" v-if="play.prices.length > 0 || play.dates.displayedText.length > 0 || play.venues.length > 0">
      <VenuesDatesPricesStrip :item="play" />
    </div>
  </div>


  <section class="section auditions" id="audition" v-if="isStatus('audition')">

    <div class="container">
      <div class="content">

        <div class="columns">
          
          <div class="column is-two-thirds">
            <h1>Apply to audition</h1>

            <p>To apply to audition, please complete the form below and we'll get back to you:</p>

            <form class="contact-form" id="contact-form" v-model="valid" ref="form" lazy-validation v-on:submit.prevent>
              <input type="hidden" name="_token" value="fasdghgfhshh" />

              <div class="field">
                <label class="label">Your name *</label>
                  <div class="control">
                    <input :disabled="form.disabled" name="name" v-model.trim="form.name" v-validate="'required|min:3'" v-bind:class="{'is-danger': errors.has('name')}" class="input" type="text" placeholder="Your name">
                  </div>
                  <p class="help is-danger" v-show="errors.has('name')">
                    {{ errors.first('name') }}
                  </p>
              </div>

              <div class="field">
                <label class="label">Your email *</label>
                <div class="control"> <!-- has-icons-left has-icons-right"> -->
                  <input :disabled="form.disabled" name="email" v-model.trim="form.email" v-validate="'required|email'" v-bind:class="{'is-danger': errors.has('email')}" class="input" type="email" placeholder="example@email.com">
                </div>
                <p class="help is-danger" v-show="errors.has('email')">
                  {{ errors.first('email') }}
                </p>
              </div>

              <div class="field">
                <label class="label">Subject</label>
                  <div class="control">
                    <input :disabled="form.disabled" name="subject" v-model.trim="form.subject" v-bind:class="{'is-danger': errors.has('subject')}" class="input" type="text" placeholder="Subject of your message">
                  </div>
                  <p class="help is-danger" v-show="errors.has('subject')">
                    {{ errors.first('subject') }}
                  </p>
              </div>

              <div class="field">
                <label class="label">Message</label>
                <div class="control">
                  <textarea :disabled="form.disabled" name="message" class="textarea" placeholder="Type your message in here" v-bind:class="{'is-danger': errors.has('message')}" v-model="form.message"></textarea>
                </div>
                <p class="help is-danger" v-show="errors.has('message')">
                  {{ errors.first('message') }}
                </p>
              </div>

              <div class="field is-grouped">
                <div class="control">
                </div>
              </div>

              <div class="field">
                <div class="control">
                  <button class="button is-primary" :class="{'is-loading': form.sendingemail}" v-bind:disabled="errors.any() || form.disabled" @click="submit">{{ form.submitbuttoncopy }}</button>
                </div>
              </div>

            </form>

          </div>

        </div>
      </div>
    </div>
  </section>

  <div v-if="play.productionteam || play.castlist">
    <section class="venues" v-if="(play.productionteam.members.length > 0) || (play.castlist.members.length > 0)">
      
      <div class="columns has-text-centered">
        <div class="column is-1"></div>
        <div class="column" v-if="play.productionteam">
          <div class="title3">{{ play.productionteam.title }}</div>
          <table class="table-productionteamcastlist">
            <tr v-for="member in play.productionteam.members" :key="member.order">
              <td class="has-text-right">{{ member.role }}</td>
              <td>{{ member.name }}</td>
            </tr>
          </table>
        </div>
        <div class="column" v-if="play.castlist">
          <div class="title3">{{ play.castlist.title }}</div>
          <table class="table-productionteamcastlist">
            <tr v-for="member in play.castlist.members" :key="member.order">
              <td class="has-text-right">{{ member.charactername }}</td>
              <td>{{ member.realname }}</td>
            </tr>
          </table>
          </ul>
        </div>
        <div class="column is-1"></div>
      </div>

    </section>
  </div>

  <div v-if="play.images">
    <section class="section white-block" v-if="play.images.length > 0">
      <div class="container">
        <div class="content">
          <h3 class="title block-title">
            Photos
          </h3>
        </div>
        <ul>
          <li class="nav-item" v-for="(image, index) in sortedImages" :key="image._id">
              <a :href="'/images/plays' + image.photo" :alt="image.caption" :title="image.caption">
                <img :src="'/images/plays' + image.photo" />
              </a>
          </li>
        </ul>
      </div> 
    </section>
  </div>


</div>
</template>

<script>
import VenuesDatesPricesStrip from './cards/VenuesDatesPricesStrip';
import Api from '@/config/Api'
//import mixins from '@/mixins/mixins'

import { mapGetters, mapState } from 'vuex'

function hexToDecimal(str) {
    var dec = parseInt(str.substr(0,12),16);
    dec = dec.toString() + parseInt(str.substr(12,12),16);
    return dec;
}

export default {
  props: ['slug'],
  //mixins: [mixins],
  components: {
    VenuesDatesPricesStrip
  },
    data() {
      return {
        play: {},
        form: {
          name: "",
          email: "",
          message: "",
          subject: "",
          disabled: false,
          sendingemail: false,
          submitbuttoncopy: "Send message"
        },
        valid: true
      }
    },
  computed: {
    ...mapGetters(['getProfile', 'isAuthenticated', 'isProfileLoaded']),
    /* ...mapState({
      authLoading: state => state.status === 'loading',
      name: state => `${state.user.profile.name}`, 
    }) */
    sortedImages() { //sort Images by latest first
    	return this.play.images.sort((a, b) => { return hexToDecimal(b._id) - hexToDecimal(a._id) });
	}
  },
  created() { 
    Api().get(`/api/plays/${this.slug}`)
    .then(response => {
      this.play = response.data;
      //this.$set(this.product, 'rrpPrice', 2);
      this.$store.commit('setContentLoaded', true); // then footer will be displayed
    })
    .catch((error) => {
      console.log("error:",error);
      console.log("error.response:",error.response);
      //const message = error.response.data.message; // || error.response.data;
      if (error.response && error.response.status == 404) {
        this.$router.push({ name: '404' });
      }
        
    });




  },
  /* updated() {
    console.log("updated");
  }, */
  methods: {
    isStatus(s) {
      if (!this.play.status) return false;
      return this.play.status.includes(s);
    },
    youtubeThumbnailFrom(fullYoutubeUrl) { //ref: https://www.sitepoint.com/faster-youtube-embeds-javascript/
      var id = fullYoutubeUrl.substr(fullYoutubeUrl.indexOf("v=")+2,11);
      return "http://img.youtube.com/vi/" + id + "/sddefault.jpg"
    },
    truncatedText(text) {
        var output = text;
        if (text) output = this.$options.filters.truncate(text, 130)
        // | truncate(130, '...')
        return output;
    },
    submit(evt) {
      evt.preventDefault()

      //Disable form...
      this.form.disabled = true;
      this.form.sendingemail = true; //show feedback spinner in button

      const { name, email, message, subject } = this.form

      var options = {
        name,
        email,
        message,
        subject,
        playtitle: this.play.title,
        messagetype: "Application to audition",
        auditionEmailRecipient: this.play.auditionEmailRecipient
      }
      //console.log("options:",options)

      Api().post(`/api/sendemail/`, options)
      .then(response => {
        //console.log("response:",response.data);
        this.$swal('Message sent!', "We'll review your message and get back to you", 'success');  
        this.form.sendingemail = false; //stop feedback spinner in button   
        this.form.submitbuttoncopy = "Message sent";  
      })
      .catch((error) => {
        /* console.log("errorrrrRR:",error);
        console.log("errorrrrRR:",error.response); */
        const message = error.response.data.message; // || error.response.data;
        if (message) {
          this.$swal('Oh oo!', `${message}`, 'error');
        } else {
          this.$swal('Uh oh!', "We couldn't send your message for some reason. Please email: secretary@combinedactors.org", 'error');
        }
        this.form.sendingemail = false; //stop feedback spinner in button  
        this.form.disabled = false;

      });

    }
  },
  metaInfo () {
    return {
      title: this.play.title,
      // titleTemplate: null // override the parent template and just use the above title only
    }
  }
  
}
</script>

<style>
.section-title {
  text-align: center;
}
.hidden {
  display: none;
}
.visible {
  display: block;
}
.realtime-message-container {
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  padding: 1rem;
}
.spinner {
  display: inline-block;
}
.realtime-message1 {
}
.realtime-message2 {
  display: block;
  /* line-height: 1.8em; */
  white-space: normal;
}
#ball-spinner {
  position: relative;
  right: .2em;
  top: .3em;
}
.toggleButton {
  text-align: center;
  margin: 1.5rem;
}

table.table-productionteamcastlist {
  margin: 0 auto;
  margin-bottom: 4em !important;
  table-layout: fixed;
  width: 100%;
  font-size: 0.95rem;
  line-height: 2em;
}
table.table-productionteamcastlist td {
  width: 100%;
  padding: 0 8px;
  word-wrap: break-word;
}

.video {
    position: relative;
    display: inline-block;
}
.video:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 10;
    background: transparent url(/images/icons/youtube-play-button.png) center center no-repeat;
}

.reviewer {
  margin-top: 0.7em;
  font-size: 0.8rem;
}

.vertical-card-gap {
  margin-bottom: 1.5rem;
}

</style>



// WEBPACK FOOTER //
// src/components/Play.vue